export const SELECT_SERVICE_EVENT = 'losbrothers:select-service'

/** Preselects a service in the booking form and scrolls to it. */
export function selectServiceAndScroll(option: string) {
  window.dispatchEvent(new CustomEvent<string>(SELECT_SERVICE_EVENT, { detail: option }))
  document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' })
}
